export const MATCH = 'match';
export const CEREMONY = 'ceremony';
export const OPEN_CEREMONY = 'Opening Ceremony';
export const CLOSE_CEREMONY = 'Closing Ceremony';
export const OPEN = 'opening';
export const CLOSE = 'closing';
export const JUDGE_SESSION = 'Judging Session';
export const PRACTICE_MATCH = 'Practice Match';
export const OFFICIAL_MATCH = 'Official Match';
export const OFFICIAL_MATCH_1 = 'Official Match 1';
export const OFFICIAL_MATCH_2 = 'Official Match 2';
export const OFFICIAL_MATCH_3 = 'Official Match 3';